'use client'
import {
  useConfig_default
} from "./chunk-UDUUTZIS.mjs";

// src/hooks/useResellConfig.ts
var useResellConfig = () => {
  return useConfig_default().resell || {};
};

export {
  useResellConfig
};
//# sourceMappingURL=chunk-L3TOSINO.mjs.map